<template>
  <div>
    <div class="page-title">
      <h3>{{'categories' | langFilter}}</h3>
    </div>
    <section>
      <Loader v-if="loading"/>
      <div class="row" v-else>
        <CategoryCreate @created="pushCategory"/>
        <CategoryEdit v-if="categories.length" :categories="categories" @edited="editCategory" :key="updCounter"/>
      </div>
    </section>
  </div>
</template>


<script>
import CategoryCreate from "@/components/CategoryCreate.vue"
import CategoryEdit from "@/components/CategoryEdit.vue"

export default {
  name: 'categories',
  metaInfo(){
    return {
      title: this.$title('categories')
    }
  },
  data: () => ({
    categories: [],
    loading: true,
    updCounter: 0
  }),
  methods: {
    pushCategory(category){
        this.categories.push(category)
        this.updCounter++
    },
    async editCategory(category){
      const idx = this.categories.findIndex(c => c.id === category.id);
      this.categories[idx].name = category.name;
      this.categories[idx].limit = category.limit;
      this.updCounter++
    }
  },
  async mounted (){
    this.categories = await this.$store.dispatch('getCategories');
    this.loading = false;
  },
  components: {
    CategoryCreate, CategoryEdit
  }
}
</script>